
import { Link } from 'react-router-dom';

const QuoteBlock = () => {
  return (
    <section className="bg-cream py-16 sm:py-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
        {/* Quote */}
        <blockquote className="mb-8 sm:mb-12">
          <p className="font-display text-2xl sm:text-4xl md:text-5xl font-black text-leather-dark leading-tight italic mb-6">
            &ldquo;The next chapter of Texas Country is already being written.&rdquo;
          </p>
          <div className="w-16 sm:w-24 h-1 bg-orange-burnt mx-auto"></div>
        </blockquote>
      </div>
    </section>
  );
};

export default QuoteBlock;
